import { render, staticRenderFns } from "./ShowFileItem.vue?vue&type=template&id=5e7f912c&scoped=true&"
import script from "./ShowFileItem.vue?vue&type=script&lang=js&"
export * from "./ShowFileItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=5e7f912c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f912c",
  null
  
)

export default component.exports